export default __webpack_public_path__ + "static/media/banner-gyn-cdg.23d9595b.png";